import React, { useState, useEffect } from "react";
import {
  Card,
  Button,
  Modal,
  Form,
  Select,
  Row,
  Col,
  Typography,
  message,
  Space,
  Tag,
  Empty,
  Divider,
} from "antd";
import { CheckCircleOutlined, ClockCircleOutlined } from "@ant-design/icons";
import { businessGroupService } from "PlatForms/OrgLMS/Services/AdminServices/businessGroupService";
import { useNavigate } from "react-router-dom";

const { Text, Title } = Typography;
const { Option } = Select;

const PendingBusinessGroups = () => {
  const [pendingGroups, setPendingGroups] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [form] = Form.useForm();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetchPendingGroups();
  }, []);

  const fetchPendingGroups = async () => {
    try {
      setLoading(true);
      const data = await businessGroupService.getPendingList();
      setPendingGroups(data);
    } catch (error) {
      console.error("Error fetching pending groups:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleApproveClick = (group) => {
    setSelectedGroup(group);
    setIsModalVisible(true);
  };

  const handleModalSubmit = async () => {
    try {
      const values = await form.validateFields();
      setIsSubmitting(true);
      await businessGroupService.approveBusinessGroup(selectedGroup.id, values.isApprove);
      message.success(
        values.isApprove
          ? "Business group approved successfully!"
          : "Business group rejected successfully!"
      );
      setIsModalVisible(false);
      fetchPendingGroups(); // Refresh the list
    } catch (error) {
      console.error("Error approving business group:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleModalCancel = () => {
    setIsModalVisible(false);
    form.resetFields();
  };

  return (
    <Card
      title="Pending Business Groups Request"
      className="card-professional"
      loading={loading}
      extra={
        <Button type="default" onClick={() => navigate("/business-groups")}>
          Back
        </Button>
      }
    >
      {pendingGroups.length === 0 && !loading ? (
        <Empty description="Data is not Available" />
      ) : (
        <Row gutter={[16, 16]}>
          {pendingGroups.map((group) => (
            <Col xs={24} sm={16} md={12} lg={12} key={group.id}>
              <Card>
                <Title
                  level={5}
                  style={{
                    marginBottom: 16,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  {group.name}
                  {group.status === 1 && (
                    <Button type="primary" onClick={() => handleApproveClick(group)}>
                      Approve
                    </Button>
                  )}
                </Title>
                <Divider />
                <Space direction="vertical" size="small" style={{ width: "100%" }}>
                  <Text>
                    <strong>Manager ID:</strong> {group.createdByManagerId}
                  </Text>
                  <Text>
                    <strong>Manager Name:</strong> {group.createdByManagerName}
                  </Text>
                  <Text>
                    <strong>Created:</strong> {new Date(group.createdOn).toLocaleDateString()}
                  </Text>
                  <div style={{ marginTop: "8px" }}>
                    <Tag
                      icon={group.status === 1 ? <ClockCircleOutlined /> : <CheckCircleOutlined />}
                      color={group.status === 1 ? "orange" : "green"}
                    >
                      {group.status === 1 ? "Pending" : "Approved"}
                    </Tag>
                  </div>
                </Space>
              </Card>
            </Col>
          ))}
        </Row>
      )}

      <Modal
        title={`Approve ${selectedGroup?.name}`}
        open={isModalVisible}
        onOk={handleModalSubmit}
        onCancel={handleModalCancel}
        okText="Submit"
        cancelText="Cancel"
        centered
        okButtonProps={{ loading: isSubmitting }}
      >
        <Form form={form} layout="vertical">
          <Form.Item
            name="isApprove"
            label="Is Approve?"
            rules={[{ required: true, message: "Please select an option" }]}
          >
            <Select placeholder="Select option">
              <Option value={true}>Yes</Option>
              <Option value={false}>No</Option>
            </Select>
          </Form.Item>
        </Form>
      </Modal>
    </Card>
  );
};

export default PendingBusinessGroups;
